import { QuestionTypeEnum } from '@/types/schema';

import Editor from '../../../components/Editor';
import { QuestionEditorProps, QuizEditField } from '../../../types';
import MtfEditorOptionsList from '../../MtfEditorOptionsList';

const MatchThefollowingEditField: QuizEditField = {
  Editor: (props: QuestionEditorProps) => (
    <Editor
      key={props.question.mtfComponent?.leftElements.length}
      EditorOptionsList={MtfEditorOptionsList}
      {...props}
    />
  ),
  type: QuestionTypeEnum.MatchTheFollowing,
};

export default MatchThefollowingEditField;
